import base from "/Users/a/Desktop/Code/frontend/monochrome/images/discord.svg?svg";
import { getParams, mergeSvgAttributes } from "svg-merge-attributes";
export default mergeSvgAttributes(base, getParams("size=22"));